/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/indent */
import Layout1 from '@/components/CourseDescriptionPageAmature/ProjectBuildingSection/Layout1';
import Layout2 from '@/components/CourseDescriptionPageAmature/ProjectBuildingSection/Layout2';
import ProjectContent from '@/components/CourseDescriptionPageAmature/ProjectBuildingSection/ProjectContent';
import ProfessionalThemeHeader from '@/components/common/Header/ProfessionalThemeHeader';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { companyImage } from '@/utils/common/env.constants';
import { Accordion, Button, Container, Dialog, Slider, Typography } from '@pwskills/rachnaui';
import React, { useContext, useState } from 'react';
import { useRouter } from 'next/router';
import Headers from '../../Header';

const ProjectSection = ({ isAmateur = true }: { isAmateur?: boolean }) => {
  const [modelOpen, setModelOpen] = useState<boolean>(false);
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { projectGallery } = courseDetails?.courseMetaDetails || {};
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  const startIndex = projectGallery?.layoutType === 'layout1' ? 4 : 6;
  const returnChildren = () => {
    return (
      <>
        <Dialog
          open={modelOpen}
          closeModal={() => {
            setModelOpen(false);
          }}
          isOutSideClick
          title="Other Projects"
          titleClass="w-full"
          className="large:!min-w-[60%]"
        >
          <div className="overflow-scroll max-h-[calc(100vh-250px)]">
            {projectGallery?.data
              ?.slice(startIndex, projectGallery?.data?.length)
              .map(({ title, desc, _id }) => {
                return (
                  <Accordion
                    title={<div className="my-2 font-bold">{title}</div>}
                    wrapperClass="bg-white"
                    className="px-0"
                    key={_id}
                  >
                    {desc}
                  </Accordion>
                );
              })}
          </div>
        </Dialog>

        {isAmateur && (
          <header
            className={isDashboard ? 'flex flex-col gap-4' : 'flex justify-center text-[#3D3D3D]'}
          >
            {isDashboard ? (
              <Typography component="h4" variant="semi-bold">
                Build Projects from Scratch
              </Typography>
            ) : (
              <Headers
                title="Build Projects from Scratch"
                classes="flex w-full !min-w-full justify-center text-gray-850 medium:w-auto text-center !self-center !w-[50%]  medium:!w-full"
              />
            )}
          </header>
        )}
        {!isAmateur && (
          <>
            {isDashboard ? (
              <Typography component="h4" variant="semi-bold">
                Build Projects from Scratch
              </Typography>
            ) : (
              <ProfessionalThemeHeader
                title="Real-World Projects: Apply What You Learn"
                wrapperClass="self-start"
              />
            )}
          </>
        )}

        {projectGallery?.layoutType === 'layout1' && (
          <Layout1 galleryProjects={projectGallery?.data?.slice(0, 4)} />
        )}
        {projectGallery?.layoutType === 'layout2' && (
          <Layout2 galleryProjects={projectGallery?.data?.slice(0, 6)} />
        )}
        <Slider
          wrapperClass="!w-full large:!hidden  flex flex-col gap-6 medium:gap-8"
          iconWrapperClass="!p-0"
          positionOfSliderInMobile="bottom"
        >
          {projectGallery?.data?.map((data) => (
            <div
              className="rounded-xl flex flex-col !shrink-0 shadow-light !w-[93%] medium:!w-[360px] !mx-3 regular:!mx-6"
              key={data?._id}
            >
              <img
                src={`${companyImage}/project_gallery/${data.img}`}
                alt={data?.title}
                className="!w-full h-[200px] rounded-t-xl"
              />
              <ProjectContent projectContent={data} />
            </div>
          ))}
        </Slider>
        {projectGallery &&
          projectGallery?.data?.slice(startIndex, projectGallery?.data?.length)?.length > 0 && (
            <Button
              variant="low-focus"
              className="!px-[72px] hidden large:flex w-fit shadow-[0_8px_24px_0px_rgba(0,0,0,0.06)] text-[#E97862] self-center"
              onClick={() => setModelOpen(true)}
            >
              View More
            </Button>
          )}
      </>
    );
  };

  if (projectGallery?.data && projectGallery?.data?.length > 0) {
    if (isDashboard) {
      return (
        <section id="projects" data-title="Projects" className="flex flex-col gap-4">
          {returnChildren()}
        </section>
      );
    }
    return (
      <section id="projects" data-title="Projects">
        <Container className="py-8 large:!py-14 flex flex-col gap-4 items-center">
          {returnChildren()}
        </Container>
      </section>
    );
  }
  return null;
};

export default ProjectSection;
